import GlobalFilterIcon from './component'

export default GlobalFilterIcon
